import { ApiEmailTemplateRepository } from 'services/repositories/implementations/ApiEmailTemplateRepository';
import { filterEmailTemplatesByEventTypeVisibility, groupEmailTemplatesByEventType } from '../utils/groupEmailTemplatesByEventType';
import { QueryKeys } from 'utils/queryKeys';
import { queryOptions } from '@tanstack/react-query';
import type { EmailTemplate } from '../types';

const mainQueryOptions = (showAllEventTypes?: boolean) => ({
  queryKey: [QueryKeys.getEmailTemplates, { showAll: showAllEventTypes ?? false }],
  queryFn: () => ApiEmailTemplateRepository.getAll(),
});

const getEmailTemplatesList = (showAllEventTypes?: boolean) =>
  queryOptions({
    ...mainQueryOptions(showAllEventTypes),
    select: (data: EmailTemplate[]) => filterEmailTemplatesByEventTypeVisibility(data ?? [], showAllEventTypes === true),
  });

const getEmailTemplatesGroupedByEventType = (showAllEventTypes?: boolean) =>
  queryOptions({
    ...mainQueryOptions(showAllEventTypes),
    select: (data: EmailTemplate[]) => groupEmailTemplatesByEventType(data ?? [], showAllEventTypes === true),
  });

export const emailTemplatesQueries = {
  getEmailTemplatesList,
  getEmailTemplatesGroupedByEventType,
};
